import { Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTranslation } from "react-i18next";
import { colors } from "../ui/tokens";

// Official store badges plus a plain button for the website.
export default function ProjectLinks({ links, dark = false }) {
  const { t, i18n } = useTranslation("Common");
  const lang = i18n.language?.startsWith("fr") ? "fr" : "en";
  const badge = {
    appstore: `/assets/linktype/${lang}appstore.svg`,
    playstore: `/assets/linktype/${lang}playstore.png`,
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.25, alignItems: "center" }}>
      {links.map((link) =>
        link.type === "web" ? (
          <Box
            key={link.url}
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              height: 44,
              px: 2,
              borderRadius: "8px",
              border: `1px solid ${dark ? "rgba(255,255,255,0.35)" : colors.line}`,
              color: dark ? colors.onDark : colors.ink,
              fontSize: "0.92rem",
              fontWeight: 600,
              textDecoration: "none",
              "&:hover": { borderColor: dark ? colors.onDark : colors.navy },
            }}
          >
            {link.label}
            <OpenInNewIcon sx={{ fontSize: "1rem", opacity: 0.7 }} />
          </Box>
        ) : (
          <Box
            key={link.url}
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t(`platforms.${link.type}`)}
            sx={{ display: "inline-flex", "&:hover": { opacity: 0.85 } }}
          >
            <Box component="img" src={badge[link.type]} alt={t(`platforms.${link.type}`)} sx={{ height: 44, width: "auto" }} />
          </Box>
        )
      )}
    </Box>
  );
}
